import { Component, Inject} from '@angular/core';
import { BallotService, EventType } from './ballot.service';
import { BehaviorSubject } from 'rxjs';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Ballot } from './backend-types';
import { Router } from '@angular/router';
import { ballotListRoute, dashboardRoute, printPageRoute, successRoute } from '../route-names';
import { BallotListService } from '../ballot-list/ballot-list.service';
import { SessionService } from '../Services/session.service';
import { ScreenOrderService, SelectedReturnMethod } from '../Services/screen-order.service';
import { ConfirmationType } from '../backend-types/misc-types';
@Component({
    selector: 'app-ballot-confirm-am',
    templateUrl: './ballot-confirm-am.component.html',
    styleUrls: ['./ballot-confirm-am.component.scss'],
    standalone: false
})
export class BallotConfirmAmComponent {

  displayProgressSpinner = false;
  signature?: string;
  readonly error = new BehaviorSubject<string>("");
  readonly isBallotError = new BehaviorSubject<boolean>(false);
  ballotType?: EventType = 'ELECTION';
  returnMethod: SelectedReturnMethod

  constructor( 
    @Inject(MAT_DIALOG_DATA) public data: {ballot?: Ballot, signature?: string},
    public dialogRef: MatDialogRef<BallotConfirmAmComponent>,
    private readonly ballotService: BallotService,
    private readonly router: Router,
    private readonly ballotListService: BallotListService,
    private readonly sessionService: SessionService,
    readonly screenOrder: ScreenOrderService
  ) {
    if(data?.ballot?.eventType?.toLowerCase().includes('poll')) {
      this.ballotType = 'POLL';
    } else if(data?.ballot?.eventType?.toLowerCase().includes('election')) {
      this.ballotType = 'ELECTION';
    } else {
      this.ballotType = 'PETITION';
    }
    this.returnMethod = this.screenOrder.selectedReturnMethod;
  }

  getError(): string {
    return this.error.getValue();
  }

  submit(): void {
    if (this.data.ballot) {
      if(!this.ballotService.isElectionLive(this.data.ballot)){
        this.error.next("ELECTION_CLOSED");
        if(this.screenOrder.routeSubmitBallotErrorToDashboard()) {
          this.router.navigate(dashboardRoute);
        } else {
          this.router.navigate(ballotListRoute);
        }
        return;
      }
      this.displayProgressSpinner = true
      if(this.screenOrder.selectedReturnMethod === "PRINT"){
        this.displayProgressSpinner = false
        this.router.navigate(printPageRoute);
        this.dialogRef.close();
      } else {
        this.ballotService.submitMarkedBallot(this.data.ballot, this.data.signature).subscribe({
          next: async (id) => {
            this.ballotListService.voted(this.ballotService.getBallot())
            this.router.navigate(successRoute, {state: {confirmationId: id, confirmationType: this.howToShowAnonID(), ballotType: this.ballotType, recurrence: this.data.ballot?.recurrenceInterval}})
          },
          error: (err) => {
            this.data.ballot = undefined;
            this.isBallotError.next(true);
            if (err.status == 504) {
                this.error.next("ERR_INTERNET_DISCONNECTED");
            }
            else {
              this.error.next(err.error.error_type);
            }
            this.displayProgressSpinner = false;
            if(this.screenOrder.routeSubmitBallotErrorToDashboard()) {
              this.router.navigate(dashboardRoute);
            } else {
              this.router.navigate(ballotListRoute);
            }
          },
          complete: () => {
            this.displayProgressSpinner = false
            this.dialogRef.close();
          }
        })
      }
    } else {
      this.dialogRef.close();
      this.sessionService.endSession();
      throw new Error('Ballot not initialized in submit modal')
    }
  }

  howToShowAnonID(): ConfirmationType | undefined {
    return this.data.ballot?.voteEventData.optionalEventConfiguration?.confirmationDeliveryChannel;
  }

  useEmail(): boolean {
    return this.howToShowAnonID()?.includes('EMAIL') ?? false;
  }
}
